import format from 'date-fns/format/index.js'
import parseISO from 'date-fns/parseISO/index.js'

export function formatDate(value) {
  return `${format(
    value instanceof Date ? value : parseISO(value),
    'd MMM, yyyy, h:mm aa'
  )}`
}
